import { ArrowRight, CircleArrowUp, CircleArrowDown } from "lucide-react";

export default function Figures({
    users,
    newUsers,
    packages,
    revenue,
    activeSubscribers,
    loadingUsers,
    loadingNewUsers,
    loadingPackages,
    loadingRevenue,
    loadingSubscribers,
}: {
    users: number,
    newUsers: number,
    packages: number,
    revenue: number,
    activeSubscribers: number,
    loadingUsers: boolean;
    loadingNewUsers: boolean;
    loadingPackages: boolean;
    loadingRevenue: boolean;
    loadingSubscribers: boolean;
}) {

    // Add this format function at the top of your component
    const formatCurrency = (amount: number): string => {
        return new Intl.NumberFormat('en-ZM', {
            style: 'currency',
            currency: 'MWK',
            minimumFractionDigits: 0,
            maximumFractionDigits: 0
        }).format(amount);
    };

    const renderValue = (value: React.ReactNode, isLoading: boolean) =>
        isLoading ? (
          <div className="h-12 w-24 bg-gray-600 animate-pulse rounded-md" />
        ) : (
          value
        );

    return (
        <div className="flex items-center justify-start gap-x-4 my-4">
            <div className="w-[260px] h-[130px] bg-card flex flex-col items-start justify-start rounded-xl p-4">
                <div className=" flex items-center gap-x-1">
                    <p className="text-white text-xs">Total Users</p>
                    <ArrowRight className="text-white w-3 h-3" />
                </div>

                <div className=" flex items-center gap-x-2 mt-4">
                    <p className="text-white text-3xl font-bold">{renderValue(users, loadingUsers)}</p>
                    <CircleArrowUp className="text-green-500 w-5 h-5" />
                </div>

                <p className="text-gray-400 text-xs pt-2"><span className="text-green-500">+10%</span> More than usual</p>

            </div>


            <div className="w-[260px] h-[130px] bg-card flex flex-col items-start justify-start rounded-xl p-4">
                <div className=" flex items-center gap-x-1">
                    <p className="text-white text-xs">Total Revenue</p>
                    <ArrowRight className="text-white w-3 h-3" />
                </div>

                <div className=" flex items-center gap-x-2 mt-4">
                    <p className="text-white text-3xl font-bold">
                        {renderValue(formatCurrency(revenue), loadingRevenue)}
                    </p>
                </div>

                <p className="text-gray-400 text-xs pt-2"><span className="text-green-500">+10%</span> More than usual</p>

            </div>


            <div className="w-[160px] h-[130px] bg-card flex flex-col items-center justify-start rounded-xl p-4">
                <div className=" flex items-center gap-x-1">
                    <p className="text-white text-xs">Packages</p>
                    <ArrowRight className="text-white w-3 h-3" />
                </div>

                <div className=" flex items-center gap-x-2 mt-4">
                    <p className="text-white text-3xl font-bold">{renderValue(packages, loadingPackages)}</p>
                    {/* <CircleArrowUp className="text-green-500 w-5 h-5" /> */}
                </div>
            </div>

            <div className="h-[130px] w-[1px] border-r border-gray-400"></div>

            <div className="w-[190px] h-[130px] bg-card flex flex-col items-start justify-start rounded-xl p-4">
                <div className=" flex items-center gap-x-1">
                    <p className="text-white text-xs">Active Subscribers</p>
                    <ArrowRight className="text-white w-3 h-3" />
                </div>

                <div className=" flex items-center gap-x-2 mt-4">
                    <p className="text-white text-3xl font-bold">
                        {renderValue(activeSubscribers, loadingSubscribers)}
                    </p>
                    {/* <CircleArrowUp className="text-green-500 w-5 h-5" /> */}
                </div>

                <p className="text-gray-400 text-xs pt-2"><span className="text-green-500">+2.30%</span> From last Month</p>

            </div>

            <div className="w-[190px] h-[130px] bg-card flex flex-col items-start justify-start rounded-xl p-4">
                <div className=" flex items-center gap-x-1">
                    <p className="text-white text-xs">New Users</p>
                    <ArrowRight className="text-white w-3 h-3" />
                </div>

                <div className=" flex items-center gap-x-2 mt-4">
                    <p className="text-white text-3xl font-bold">{renderValue(newUsers, loadingNewUsers)}</p>
                    <CircleArrowDown className="text-red-500 w-5 h-5" />
                </div>

                <p className="text-gray-400 text-xs pt-2"><span className="text-red-500">-2.30%</span> From last Month</p>

            </div>
        </div>
    );
}